import { Dispatch, FC, SetStateAction } from "react";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row } from "../../BaseComponents/Flex";

interface SupportModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
}

const SupportModal: FC<SupportModalProps> = ({
  title,
  message,
  acceptButtonText,
  rejectButtonText,
  setIsOpen,
}) => {
  const onRejectClick = (): void => setIsOpen(false);

  return (
    <Modal
      info={message}
      maxWidth={450}
      setIsOpen={setIsOpen}
      title={title}
      isClosable={false}
    >
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button onClick={onRejectClick} text={rejectButtonText} />
        </Col>
      </Row>
    </Modal>
  );
};

export default SupportModal;
